// ! --- Sitemap Generator Configuration ---
export const BASE_URL = 'https://www.lottoland.co.za'; // !Please ensure this has the prod host
export const EXCLUDED_PATHS = ['.', '[', ']', 'component', 'currency-format', 'my-account', 'navigation', 'robots'];
export const DEFAULT_CHANGE_FREQ = 'weekly'; // TODO: Define default change frequency for pages as fallback
export const DEFAULT_PRIORITY = 0.7; // TODO: Define default priority for pages as fallback
